module.exports = __webpack_public_path__ + "static/img/WS-100W.b062c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/WS-100W.png
// module id = a6k8
// module chunks = 4